import { breakdownDealComponent } from "../../helpers/hummingbirdHelpers";

export function getMealPlanDescription(supplierInfo, code) {
  if (!supplierInfo) return null;

  const hotelDetails = supplierInfo.supplier.hbt_hotel_details;
  const { mealPlans } = hotelDetails;
  const theMealPlan = mealPlans.find((r) => r.code === code);

  if (!theMealPlan) return null;

  return theMealPlan.details;
}

export function getMealPlanName(supplierInfo, code) {
  if (!supplierInfo) return null;

  const hotelDetails = supplierInfo.supplier.hbt_hotel_details;
  const { mealPlans } = hotelDetails;
  const theMealPlan = mealPlans.find((r) => r.code === code);

  if (!theMealPlan) return null;

  return theMealPlan.name;
}

export function getMarginMarkup(supplierInfo) {
  if (!supplierInfo) return 0;
  const margin = supplierInfo.supplier.hbt_margin;

  if (margin === null) return 0;

  return margin;
}

export function applyMarkup(price, paymentMarkup, marginMarkup) {
  if (marginMarkup === 1) {
    return price;
  }

  return (price / (1 - marginMarkup / 100)) * paymentMarkup;
}

export function applyRoomMarkup({
  price,
  theRoom,
  paymentMarkup,
  applyMarkup,
}) {
  if (!theRoom) {
    return price;
  }

  const { hbt_margin } = theRoom;

  if (hbt_margin === null) {
    return applyMarkup(price);
  }

  return (price / (1 - hbt_margin / 100)) * paymentMarkup;
}

export function getHbtDeal({ dealId, groupsResult, selectedGroupId }) {
  const components = breakdownDealComponent(dealId);

  const theGroup = groupsResult.find((group) => {
    return group.id === selectedGroupId;
  });

  if (!theGroup || !theGroup.rooms) return 0;

  const theRoom = theGroup.rooms.find((room) => {
    return room.code === components.roomCode;
  });

  if (!theRoom || !theRoom.deals) return 0;

  const theDeal = theRoom.deals.find((deal) => {
    return deal.id === dealId;
  });

  return theDeal;
}
